export default {
  company: 'חברה מנהלת',
  uid: 'מספר מזהה',
  alternativeFundName: 'שם קרן אלטרנטיבית',
  branch: 'מוצר',
  accordType: 'סוג עמלה',
  alternativeFundType: 'סוג קרן אלטרנטיבית',
  number: 'מספר קרן אלטרנטיבית',
  commission: 'עמלה %',
  comments: 'הערות',
};
